
import React from "react";
import { PopupType } from "./types";

interface HorrorTitleProps {
  messageType: PopupType;
  glitching: boolean;
}

export const HorrorTitle = ({ messageType, glitching }: HorrorTitleProps) => {
  const getTitle = () => {
    switch (messageType) {
      case "achievement":
        return "ACHIEVEMENT UNLOCKED";
      case "level":
        return "ADVANCEMENT DETECTED";
      case "weight":
        return "MASS FLUCTUATION";
      case "diet":
        return "CONSUMPTION RECORD";
      default:
        return "SYSTEM MESSAGE";
    }
  };

  return (
    <div className="mb-2 text-center relative">
      <h3 className={`text-lg uppercase tracking-widest ${glitching ? 'animate-pulse' : ''}`}>
        {getTitle()}
      </h3>
      <div className="w-full h-px bg-current opacity-50 mt-1"></div>
    </div>
  );
};

